import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Utility } from '../../../../../../Autofacets-Core/src/app/utils/utility';
import { UserDataService } from '../../../../../../../src/app/DataServices/user-data.service';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { DealerHolidayBusinessService } from '../../../business-services/dealer-holiday.service';
import { Constant } from './../../../../../../Autofacets-Core/src/app/utils/constant';
import { DealerHolidaySaveViewModel, DealerHolidayViewModel } from './../../../business-entities/dealer-holiday-list-view-model';
import { TranslateService } from '@ngx-translate/core';
import { AdminCommonService } from '../../../services/admin-common.service';

@Component({
    selector: 'app-add-dealer-holiday',
    templateUrl: './add-dealer-holiday.component.html'
})


export class AddDealerHolidayComponent implements OnInit {
    dealerId: string;
    dealerSelected: {value:string, text:string}[] = [];
    startDate: string;
    endDate: string;
    dealerList: SelectListItemViewModel[];
    selectedDealerId: string;
    addDealerHolidayForm: FormGroup;
    isValidDate = true;
    dealerHolidayViewModel: DealerHolidayViewModel;
    dealerHolidaySaveViewModel: DealerHolidaySaveViewModel;
    dropdownSettings: {};
    constructor(
        private adminCommonService :AdminCommonService,
        private formBuilder: FormBuilder,
        public dealerHolidayBusinessService: DealerHolidayBusinessService,
        private toastr: ToastrService,
        private userService: UserDataService,
        private activeModal : NgbActiveModal,
        private translate: TranslateService,
    ) { }

    ngOnInit(): void {
        this.addDealerHolidayForm = this.formBuilder.group({
            dealer: ['', [Validators.required]],
            name: ['', [Validators.required]],
            startDate: [''],
            endDate: ['']
        });
        this.initializeModel();
        this.getdealerHolidayViewModel();
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'value',
            textField: 'text',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 5,
            allowSearchFilter: true,
            searchPlaceholderText: 'Search here',
            maxHeight: 500
          };
    }

    async getdealerHolidayViewModel() {
            this.dealerList = this.dealerHolidayBusinessService.dealerList;
            if(this.dealerList.length === 1){
                this.dealerSelected = this.dealerList;
            }
    }

    get cpf() {
        return this.addDealerHolidayForm.controls;
    }
    initializeModel() {
        this.dealerHolidayViewModel = {
            id: 0,
            dealerId: '0',
            name: '',
            dealerName: '',
            startDate: '',
            endDate: '',
            dealerList:[]
        };
    }

    
    onSubmit(): void {
        if (this.addDealerHolidayForm.invalid) {
            return;
        }
        let endDate = Utility.ConvertLocalDateToUTCDate(Utility.getDateStringToDate(this.addDealerHolidayForm.value.endDate))
        let startDate = Utility.ConvertLocalDateToUTCDate(Utility.getDateStringToDate(this.addDealerHolidayForm.value.startDate));
        this.dealerHolidaySaveViewModel=
        {
            id: 0,
            dealerId: this.selectedDealerId,
            name: this.addDealerHolidayForm.value.name,
            dealerName: this.addDealerHolidayForm.value.dealerName,
            startDate: startDate,
            endDate: endDate,
            dealerList: this.dealerSelected
        }

        //Date validation
        if (this.validateDateTime(new Date(startDate),new Date(endDate))) {
            this.dealerHolidayBusinessService.editDealerHolidays(this.dealerHolidaySaveViewModel).then((response) => {
                if (response.responseCode === Constant.SuccessResponseCode) {
                    if(response.responseObject.isValid == 1 && response.responseObject.name != null){
                        let errorMsg = this.translate.instant('lblHolidayNotAdded') +' ' + response.responseObject.name.replace(/^,/, '');
                        this.toastr.error(errorMsg);
                    }
                    else if(response.responseObject.isValid == 0 && response.responseObject.name != null){
                        let errorMsg = this.translate.instant('lblPlanningPresent') + ' ' + response.responseObject.name.replace(/^,/, '');
                        this.toastr.error(errorMsg);
                    }
                    else{
                        this.toastr.success(Constant.SuccessfullyAdded);
                        this.activeModal.close({ success: true });
                    }
                }
            });
        }
    }
    convertDate(d: any) {
        let parts = d.split(" ");
        let months = { Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06", Jul: "07", Aug: "08", Sep: "09", Oct: "10", Nov: "11", Dec: "12" };
        return parts[3] + "-" + months[parts[1]] + "-" + parts[2];
    }

    validateDates(sDate: string, eDate: string) {
        if (sDate == null || eDate == null) {
            this.toastr.error(Constant.DateValidation);
            return !this.isValidDate;
        }

        if (eDate < sDate) {
            this.toastr.error(Constant.DateRangeValidation);
            return !this.isValidDate;
        }
        return this.isValidDate;
    }

    validateDateTime(startDate:Date,endDate:Date)
    {
        if(endDate<startDate)
        {
            this.toastr.error(Constant.DateRangeValidation);
            return !this.isValidDate;
        }
        return this.isValidDate;
    }
    OnClose(){
        this.activeModal.dismiss('Cross click')
    }
}
